import { createDivIn, createHeaderIn, createImgIn, createParagraphIn, setElementOnClick } from '../ui_utils/DomUtils.ts';
import { LobbyImage, ColonistMembershipType } from '@colonist/types';
import { ColonistMembershipProduct } from '../../../../shared/store/ColonistMembershipProduct.ts';
import { ColonistMembershipPerkType } from '@colonist/lobby-types';
import { showSimpleDialog } from '../ui_popup/showSimpleDialog.ts';
import { navigateToPage } from '../ui_utils/ClientUtils.ts';
import { UIUtilsEjsVariables } from '../UIUtilsEjsVariables.ts';
import { isSubscriptionOverlayVisible } from './subscription_overlay/subscriptionOverlayABTest.ts';
export class UIMembershipProductView {
    createPerks() {
        const bodyGridDiv = createDivIn(this.bodyDiv, 'store_page_membership_grid', '');
        const topMembership = ColonistMembershipProduct.getMembershipProduct(ColonistMembershipType.EliteMonthly);
        const allPerks = this.getValidMembershipPerks(topMembership);
        for (const perk of allPerks)this.createPerkIn(bodyGridDiv, perk);
    }
    createPerkIn(container, perk) {
        const perkCheckDiv = createDivIn(container, '', '');
        const perkCheckIcon = createImgIn(perkCheckDiv, perk.imageUrl);
        const perkTextDiv = createDivIn(container, '', '');
        const perkText = createParagraphIn(perkTextDiv, perk.description, '', '');
        const infoIcon = UIMembershipProductView.createInfoIcon(container, perk);
        if (!this.isPerkActive(perk)) {
            perkCheckIcon.style.display = 'none';
            perkText.style.opacity = '50%';
            infoIcon.style.opacity = '50%';
        }
    }
    addBestValueHint() {
        if (!this.membershipProduct.bestValue) return;
        this.productDiv.classList.add('store_page_membership_best_value_border');
        const badge = createDivIn(this.headerDiv, 'badge-white badge-lg');
        createParagraphIn(badge, {
            key: 'strings:storePage.bestValue'
        }, '');
    }
    // eslint-disable-next-line class-methods-use-this
    getValidMembershipPerks(membership) {
        const perks = structuredClone(membership.perks);
        for (const inactivePerks of membership.perks){
            if (perks.some((perk)=>perk.type == inactivePerks.type)) continue;
            if (inactivePerks.type == ColonistMembershipPerkType.FullReplay) continue;
            perks.push(inactivePerks);
        }
        UIMembershipProductView.mergeMapsAndExpansionDescriptions(perks);
        return perks;
    }
    static mergeMapsAndExpansionDescriptions(perks) {
        const mapPerk = perks.find((perk)=>perk.type == ColonistMembershipPerkType.AllMaps);
        const expansionPerk = perks.find((perk)=>perk.type == ColonistMembershipPerkType.AllExpansions);
        if (!mapPerk || !expansionPerk) return perks;
        const mapPerkIndex = perks.indexOf(mapPerk);
        perks.splice(mapPerkIndex, 1);
        expansionPerk.description = {
            key: 'strings:storePage.sections.membership.perks.allMapsAndExpansions'
        };
        return perks;
    }
    isPerkActive(perk) {
        return this.membershipProduct.perks.some((activePerk)=>activePerk.type == perk.type);
    }
    static createInfoIcon(parentDiv, perk) {
        const perkInfoDiv = createDivIn(parentDiv, '', '');
        const perksWithInfoIcon = [
            ColonistMembershipPerkType.AllExpansions,
            ColonistMembershipPerkType.AllMaps,
            ColonistMembershipPerkType.BasicReplay,
            ColonistMembershipPerkType.FullReplay,
            ColonistMembershipPerkType.PremiumMatchmaking
        ];
        const shouldShowIcon = perksWithInfoIcon.includes(perk.type);
        if (!shouldShowIcon) return perkInfoDiv;
        const perkInfoIcon = createImgIn(perkInfoDiv, LobbyImage.InfoIcon);
        UIMembershipProductView.createClickEventForInfoIcon(perkInfoIcon, perk.type);
        return perkInfoDiv;
    }
    static createClickEventForInfoIcon(infoIcon, perkType) {
        if (perkType == ColonistMembershipPerkType.PremiumMatchmaking) {
            setElementOnClick(infoIcon, ()=>UIMembershipProductView.createInfoPopupForPremiumMatchmaking(), false, true);
            return;
        }
        setElementOnClick(infoIcon, ()=>UIMembershipProductView.createInfoPopupForMapsAndExpansions(), false, true);
    }
    static createInfoPopupForPremiumMatchmaking() {
        const popupTitle = {
            key: 'strings:storePage.sections.membership.perks.premiumMatchmaking.title'
        };
        const popupBody = {
            key: 'strings:storePage.sections.membership.perks.premiumMatchmaking.description'
        };
        showSimpleDialog({
            title: popupTitle,
            body: popupBody
        });
    }
    static createInfoPopupForMapsAndExpansions() {
        showSimpleDialog({
            title: {
                key: 'strings:storePage.FAQ.title'
            },
            body: 'strings:storePage.FAQ.body',
            confirmLabel: {
                key: 'strings:homePage.footer.faq'
            },
            onConfirm: ()=>UIMembershipProductView.navigateToFaq()
        });
    }
    static navigateToFaq() {
        const isPageNavigatedInApp = UIUtilsEjsVariables.isUserOnDiscord || UIUtilsEjsVariables.isUserOnMobileAppOrWeb;
        const shouldOpenFaqInNewTab = isSubscriptionOverlayVisible() && !isPageNavigatedInApp;
        navigateToPage('/faq', shouldOpenFaqInNewTab, true);
    }
    constructor(container, membershipProduct){
        this.membershipProduct = membershipProduct;
        this.productDiv = createDivIn(container, 'store_page_membership', '');
        const headerDivClass = 'store_page_membership_header ' + this.membershipProduct.membershipColor;
        this.headerDiv = createDivIn(this.productDiv, headerDivClass, '');
        createImgIn(this.headerDiv, this.membershipProduct.lobbyImage, 'header_background_image');
        createImgIn(this.headerDiv, this.membershipProduct.lobbyImage);
        createHeaderIn(this.headerDiv, this.membershipProduct.membershipTitle, '', '', 'H2');
        this.bodyDiv = createDivIn(this.productDiv, 'store_page_membership_body', '');
        this.createPerks();
        this.addBestValueHint();
    }
}
